// 接口 - 企微管理
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi, hnBase} = apiPrefix;

// 获取企微对应公司主体
export const getCompanyBodyOptions = params => get(`${baseApi}/robotAccount/company`, params);
// 用户管理 - 列表
export const getUserList = params => post(`${baseApi}/robotAccount/getList`, params);
// 用户管理 - 导出
export const exportUserList = (params) => post(baseApi + '/robotAccount/getList/download', params, {responseType: 'blob'});
// 用户管理 - 新增、修改
export const userAddOrUpdate = params => post(`${baseApi}/robotAccount/update`, params);
// 用户管理 - 拉取圈量数据
export const pullJingyuData = params => get(`${hnBase}/work_wexin_talk/api/account/reloadRotbotList`, params);
// 用户管理 - 新增主体
export const companyAdd = params => post(`${baseApi}/robotAccount/company`, params);
// 用户管理 - 枚举选项
export const enumOptions = params => get(`${baseApi}/robotAccount/enumOptions`, params);
// 用户管理 - 确认录音是否核准通过
export const voiceCheck = params => post(`${baseApi}/robotAccount/checkUrl`, params);

// 用户管理 - 录音整段上传
export const voiceBatchUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(`${baseApi}/robotAccount/save/recording`, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}

// 企微账号池 - 上传手机号 Excel，查询并累计返回企微账号
export const uploadPhoneExcel = (params) => {
    const data = new FormData();
    Object.keys(params).forEach((item) => {
        data.append(item, params[item]);
    });

    return post(`${baseApi}/robotAccount/upload/phones`, data, {
        headers: {"Contennt-Type": "multipart/form-data",},
        noValid: true,
    });
}
// 企微账号池 - 清除当前登录人的 Excel 查询结果缓存
export const clearCache = params => get(`${baseApi}/robotAccount/upload/clearCache`, params);
// 企微账号池 - 下载当前登录人的手机号查询失败记录
export const downloadFailures = params =>  get(baseApi + "/robotAccount/upload/failures/download", params, {responseType: "blob"})
// 企微账号池 - 批量将企微账号应用状态修改为上线
export const batchOnline = params => post(`${baseApi}/robotAccount/batch/online`, params);

